import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, mergeProps as _mergeProps, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["id"]

import { toRef, useAttrs, watch } from 'vue';
import { useField } from 'vee-validate';
import InputText from 'primevue/inputtext';
import { Nullable } from 'primevue/ts-helpers';
import { computed } from '@vue/reactivity';

const __default__ = {
    inheritAttrs: false
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'InputTextWithLabel',
  props: {
    name: {},
    label: {},
    modelValue: {},
    placeholder: { default: 'Chọn một' },
    type: { default: 'text' },
    smallLabel: {}
  },
  setup(__props: any) {

const props = __props;


const attrs = useAttrs();
const attrsNotIncludeClass = computed(() => {
    return {
        ...attrs, ...{ class: null }
    };
})
const { errorMessage, value } = useField<Nullable<string>>(toRef(props, 'name'), undefined, {
    initialValue: props.modelValue
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$attrs.class)
  }, [
    _createElementVNode("label", { for: _ctx.name }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.smallLabel)
        ? (_openBlock(), _createElementBlock("small", _hoisted_2, _toDisplayString(_ctx.smallLabel), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    _createVNode(_unref(InputText), _mergeProps({
      id: _ctx.name,
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
      type: _ctx.type
    }, _unref(attrsNotIncludeClass), {
      class: { 'p-invalid': _unref(errorMessage) },
      "aria-describedby": `${_ctx.name}-help`
    }), null, 16, ["id", "modelValue", "type", "class", "aria-describedby"]),
    _createElementVNode("small", {
      id: `${_ctx.name}-help`,
      class: "p-error"
    }, _toDisplayString(_unref(errorMessage)), 9, _hoisted_3)
  ], 2))
}
}

})